import { jsx } from 'react/jsx-runtime';
import { codeSyntaxHighlightLightMode, codeSyntaxHighlightDarkMode } from './codeSyntaxHighlight.js';
import { renderCssBasedOnColorScheme } from './renderCssBasedOnColorScheme.js';
import Color from 'color';
import { createGlobalStyle } from 'styled-components';
import { CSS_THEME } from './theme.js';
import { colorToRGBCssString, colorToHSLCssString } from './utils.js';
import { isTruthy } from '@fabric-app/utils/guards';

const transformDefinitionToVariables = () => {
  const res = Object.entries(CSS_THEME).reduce((res2, [key]) => {
    return {
      ...res2,
      [key]: `var(--fabric-${key})`,
      [`${key}-rgb`]: `var(--fabric-${key}-rgb)`,
      [`${key}-hsl`]: `var(--fabric-${key}-hsl)`
    };
  }, {});
  return res;
};
const generateCssVariablesStylesheetDark = () => {
  const darkTheme = Object.entries(CSS_THEME).map(([key, value]) => {
    if (value.definitionType === "color" && "dark" in value) {
      const color = new Color(value.dark);
      return `
          --fabric-${key}: ${value.dark};
          --fabric-${key}-rgb: ${colorToRGBCssString(color)};
          --fabric-${key}-hsl: ${colorToHSLCssString(color)};
      `;
    }
    return null;
  }).filter(isTruthy);
  return darkTheme;
};
const generateCssVariablesStylesheet = () => {
  const lightTheme = Object.entries(CSS_THEME).map(([key, value]) => {
    if (value.definitionType === "color") {
      const color = new Color(value.light);
      return `
        --fabric-${key}: ${value.light};
        --fabric-${key}-rgb: ${colorToRGBCssString(color)};
        --fabric-${key}-hsl: ${colorToHSLCssString(color)};
      `;
    } else {
      return `--fabric-${key}: ${value.value};`;
    }
  });
  return lightTheme;
};
const lightThemeStylesheet = generateCssVariablesStylesheet();
const darkThemeStylesheet = generateCssVariablesStylesheetDark();
const cssVar = transformDefinitionToVariables();
const GlobalStylesheetCssVariables = createGlobalStyle([
  `hr{border-top-color:`,
  `;}html:not(.todesktop-platform-darwin),html:not(.todesktop-platform-darwin) body{background-color:`,
  `;}`,
  `{`,
  ` `,
  `}`
], cssVar["color-border-primary"], cssVar["color-bg-primary"], (p) => p.host ? ":host" : ":root", renderCssBasedOnColorScheme({
  light: lightThemeStylesheet,
  dark: darkThemeStylesheet
}), renderCssBasedOnColorScheme({
  light: codeSyntaxHighlightLightMode,
  dark: codeSyntaxHighlightDarkMode
}));
const AppThemeStylesheet = (props) => {
  return /* @__PURE__ */ jsx(GlobalStylesheetCssVariables, {
    ...props
  });
};

export { AppThemeStylesheet, cssVar, darkThemeStylesheet, lightThemeStylesheet };
//# sourceMappingURL=variables.js.map
